import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-notify',
  templateUrl: './notify-popup.component.html',
  styleUrls: ['./notify-popup.component.scss']
})
export class NotifyPopupComponent implements OnInit {
  @Input() data: any;
  constructor(private commonService: CommonService,
    private route: Router) { }

  ngOnInit(): void {
  }

  close() {
    this.commonService.closePopUp();
    if (this.data?.popUpType === 'reset-password') {
      this.route.navigate([''])
    }
  }

}
